import { runDemo } from "../shared/demoRunner";
import { createShadowsScene } from "./scene";

runDemo({
    createScene: createShadowsScene,
});
